import { createSelector } from '@reduxjs/toolkit';

import { SharingInvitationStatus } from '@/shared/api/protocol-ts/model/dto_sharing_pb';

import { RootState } from '@/app/model/store';

import { sharingAdapter } from './sharingSlice';

export const sharingSelectors = sharingAdapter.getSelectors(
  (state: RootState) => state.sharing,
);

export const { selectAll, selectById, selectTotal, selectEntities, selectIds } =
  sharingSelectors;

export const selectSharingLoading = (state: RootState) => state.sharing.loading;

export const selectSharingInvitationByToken = (token: string) =>
  createSelector(sharingSelectors.selectAll, (invitations) =>
    invitations.find((invitation) => invitation.Token === token),
  );

export const selectAcceptedOrPendingSharedPatientInvitations = createSelector(
  sharingSelectors.selectAll,
  (invitations) =>
    invitations.filter(
      (invitation) =>
        invitation.Status ===
          SharingInvitationStatus.SharingInvitationStatus_Pending ||
        invitation.Status ===
          SharingInvitationStatus.SharingInvitationStatus_Accepted,
    ),
);
